import { useMutation, useQuery } from '@apollo/client';
import { Box, Typography, Snackbar, Alert } from '@mui/material';
import 'react-quill/dist/quill.snow.css';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CreateQuestionInput, Role } from '../__generated__/graphql';
import { GET_ME } from '../graphql/getMe';
import { QuestionFormStyles } from '../styles/QuestionFormStyles';
import { CREATE_QUESTION } from '../graphql/createQuestion';
import QuestionForm from '../components/QuestionForm';

const CreateQuestion = () => {
  const navigate = useNavigate();
  const { data: me, loading: meLoading } = useQuery(GET_ME);
  const [createQuestion] = useMutation(CREATE_QUESTION);
  const [notification, setNotification] = useState<{
    open: boolean;
    message: string;
    severity: 'success' | 'error';
  }>({
    open: false,
    message: '',
    severity: 'success',
  });

  useEffect(() => {
    if ((!me && !meLoading) || Role.User === me?.getMe?.role) {
      navigate('/login');
    }
  }, [me, meLoading, navigate]);

  const handlePublish = (createQuestionInput: CreateQuestionInput) => {
    createQuestion({
      variables: {
        createQuestionInput,
      },
    })
      .then(() => {
        setNotification({
          open: true,
          message: 'Question published successfully!',
          severity: 'success',
        });
        setTimeout(() => navigate('/dashboard'), 1500);
      })
      .catch((error) => {
        console.error('Error creating question:', error);
        setNotification({
          open: true,
          message: 'Failed to publish question. Please try again.',
          severity: 'error',
        });
      });
  };

  return (
    <Box sx={QuestionFormStyles.container}>
      <Typography sx={QuestionFormStyles.header}>
        Create New Question
      </Typography>
      <QuestionForm
        onSubmit={(createQuestionInput) =>
          handlePublish(createQuestionInput as CreateQuestionInput)
        }
      />
      <Snackbar
        open={notification.open}
        autoHideDuration={4000}
        onClose={() => setNotification((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setNotification((prev) => ({ ...prev, open: false }))}
          severity={notification.severity}
          sx={{ width: '100%' }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateQuestion;
